import axiosInstance from "./axios";

export const createBattleQuestion = async (data) => {
    const response = await axiosInstance.post("/battle-question/create", data);
    return response.data;
};

export const getBattleQuestions = async (params) => {
    const response = await axiosInstance.get("/battle-question/find", { params });
    return response.data;
};

export const updateBattleQuestion = async (id, data) => {
    const response = await axiosInstance.put(`/battle-question/update/${id}`, data);
    return response.data;
};

export const deleteBattleQuestion = async (id) => {
    const response = await axiosInstance.delete(`/battle-question/delete/${id}`);
    return response.data;
};

export const deleteMultipleBattleQuestions = async (ids) => {
    const response = await axiosInstance.post("/battle-question/delete-multiple", { ids });
    return response.data;
};